define([
    'query-string'
], (queryString)=> {

    return queryString.parse(window.location.search);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/segmentation/queryparams/QueryParamsData.js